// extracted by mini-css-extract-plugin
export default {"app":"styles_app__W64CE","toast":"styles_toast__QH51R"};